import { useState, useEffect } from "react";
import { apiGet, ApiError } from "./api";
import "./QrRedirect.css";

// iPadOS se présente comme un Mac : le tactile fait la différence.
// Partagé avec App.js : /register/{org} sans ?platform= détecte aussi l'appareil.
export function isIos() {
  const ua = navigator.userAgent;
  return /iPhone|iPad|iPod/.test(ua) || (/Macintosh/.test(ua) && "ontouchend" in document);
}

function QrRedirect({ qrId }) {
  // loading | placeholder | invalid | error
  const [state, setState] = useState("loading");

  useEffect(() => {
    apiGet(`/api/qr-links/${qrId}/resolve`)
      .then((data) => {
        if (data.configured) {
          const platform = isIos() ? "apple" : "android";
          window.location.replace(`/register/${data.org_id}?platform=${platform}`);
        } else {
          setState("placeholder");
        }
      })
      .catch((e) => {
        setState(e instanceof ApiError && e.status === 404 ? "invalid" : "error");
      });
  }, [qrId]);

  // Page ouverte depuis l'appareil d'un client : un écran blanc pendant la
  // résolution ressemble à un QR cassé.
  if (state === "loading") {
    return (
      <div className="qrr-container">
        <div className="qrr-card">
          <span className="rc-wordmark qrr-brand">Racines</span>
          <p>Chargement...</p>
        </div>
      </div>
    );
  }

  return (
    <div className="qrr-container">
      <div className="qrr-card">
        <span className="rc-wordmark qrr-brand">Racines</span>
        {state === "placeholder" && (
          <>
            <h1>Ce QR code n'est pas encore activé</h1>
            <p>Le programme de fidélité de ce commerce sera bientôt disponible. Revenez très vite !</p>
          </>
        )}
        {state === "invalid" && (
          <>
            <h1>QR code inconnu</h1>
            <p>Ce lien ne correspond à aucun QR code. Vérifiez auprès du commerçant.</p>
          </>
        )}
        {state === "error" && (
          <>
            <h1>Service momentanément indisponible</h1>
            <p>Impossible de contacter le serveur. Réessayez dans quelques instants.</p>
          </>
        )}
        <span className="qrr-footer">Fidelity-card.fr</span>
      </div>
    </div>
  );
}

export default QrRedirect;
